import { CertificationRequestUpdateDialogComponent } from '@/components/certification-request-update-dialog/certification-request-update-dialog.component';
import { ConfirmDialogComponent } from '@/components/confirm-dialog/confirm-dialog.component';
import { CertificationHelper } from '@/helpers/certification.helper';
import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { Paging } from '@/models/Paging';
import { AlertService } from '@/services/alert.service';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CertificationRequest, CertificationType, CertificationsService } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { DateTimeFormatPipe } from '@/extensions/dateTimePipe';
import { NgIf } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-admin-certification-requests',
    templateUrl: './admin-certification-requests.component.html',
    styleUrls: ['./admin-certification-requests.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatIconModule, MatInputModule, MatSlideToggleModule, MatTableModule, MatSortModule, MatButtonModule, RouterLink, MatMenuModule, MatPaginatorModule, NgIf, DateTimeFormatPipe]
})
export class AdminCertificationRequestsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<CertificationRequest>;
  displayFullColumns = false;
  tableClass = 'light';
  lightColumns = ['propertyName', 'propertyOwnerName', 'date', 'status', 'actions'];
  fullColumns = ['propertyName', 'propertyOwnerName', 'date', 'status', 'message', 'uid', 'actions'];
  displayedColumns = [];
  resultsLength = 0;
  displayValidated = false;

  sub = new Subscription();
  sortSub = new Subscription();
  deleteSub = new Subscription();

  paging = new Paging();

  constructor(
    private certificationService: CertificationsService,
    private dialog: MatDialog,
    private alertService: AlertService,
    private changeDetectorRefs: ChangeDetectorRef,
    public propHelper: PropertyHelper,
    public certifHelper: CertificationHelper,
    public userHelper: UserHelper
  ) {
    this.displayedColumns = this.lightColumns;
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    let filter: string;
    if (this.dataSource && this.dataSource.filter) {
      filter = this.dataSource.filter;
    }
    // TODO manage certification type & pagination
    this.sub = this.certificationService
      .getCertificationRequests(CertificationType.OWNER, this.displayValidated)
      .subscribe((data) => {
        const displayedData = [];
        data.list.forEach((i) => {
          const row = {
            request: i,
            propertyName: i.property.name,
            owner: UserHelper.userSummmaryDisplayName(i.propertyOwner),
            status: this.certifHelper.getCertificationsRequestStatusName(i.status)
          };
          displayedData.push(row);
        });
        this.dataSource = new MatTableDataSource(displayedData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (filter) {
          this.applyFilter(filter);
        }
      });
  }

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sortSub = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  toggleDisplayColumns() {
    if (this.displayFullColumns) {
      this.displayFullColumns = false;
      this.displayedColumns = this.lightColumns;
      this.tableClass = 'light';
    } else {
      this.displayFullColumns = true;
      this.displayedColumns = this.fullColumns;
      this.tableClass = 'full';
    }
    this.changeDetectorRefs.detectChanges();
  }

  toggleStatusDisplay() {
    this.displayValidated = !this.displayValidated;
    this.loadData();
  }

  confirmDelete(request: CertificationRequest) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message: "Confirmez-vous l'annulation de la demande de certification ?"
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.doDelete(request);
          this.loadData();
        }
      });
    }
  }

  doDelete(request: CertificationRequest) {
    this.deleteSub = this.certificationService.deleteCertificationRequest(request.uid).subscribe((result) => {
      this.alertService.success('Demande de certification annulée');
      this.loadData();
    });
  }

  edit(requestToEdit: CertificationRequest) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(CertificationRequestUpdateDialogComponent, {
        // width: '20rem'
        data: { request: requestToEdit }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadData();
        }
      });
    }
  }
}
